import { HAS_OIDC_COOKIE_STATE_KEY } from '~/utils/shop/hasOidcSessionCookie';

/**
 * Seeds `shop-auth-status` on the client when an OIDC cookie is present.
 * Guests keep the default `{ entra: false, shop: false }` without a request.
 */
export default defineNuxtPlugin({
  name: 'shop-auth-status',
  enforce: 'pre',
  async setup() {
    // Default true: if the SSR flag is missing, still fetch (safe).
    if (!useState(HAS_OIDC_COOKIE_STATE_KEY, () => true).value) {
      return;
    }

    await useShopAuth().syncStatus();
  }
});
